import { Icon } from '@chakra-ui/react';

export const AddIcon = (props: any) => (
  <Icon aria-label="add icon" viewBox="-4 -4 24 24" {...props}>
    <path fill="currentColor" d="m9 3v4h4v2h-4v4h-2v-4h-4v-2h4v-4z" />,
  </Icon>
);
